document.addEventListener('DOMContentLoaded', function () {

    const header = document.querySelector('.LpSokolHeader');

    if (!header) return;

    handleHeaderBackground();

    // white bg on scroll
    window.addEventListener('scroll', function () {

        handleHeaderBackground();

    });

    function handleHeaderBackground() {
        if (window.scrollY > 0) {
            header.classList.add('is-scrolled');
        }
        else {
            header.classList.remove('is-scrolled');
        }
    }
});